import '../../sass/blocks/landing-page-faqs.scss';

import Details from '../classes/Details';

(() => {
    const $LandingPageFaqs = document.querySelectorAll('.landing-page-faqs');

    if (!$LandingPageFaqs) return;

    $LandingPageFaqs.forEach($LandingPageFaq => {
        const $dropdowns = $LandingPageFaq.querySelectorAll('.landing-page-faq');

        const initDetails = () => {
            if (!$dropdowns) return;

            $dropdowns.forEach($dropdown => {
                new Details($dropdown);
            });
        };

        initDetails();
    })
})();
